import { render } from "./txssc.vue?vue&type=template&id=31d29007&scoped=true"
import script from "./txssc.vue?vue&type=script&lang=js"
export * from "./txssc.vue?vue&type=script&lang=js"

import "./txssc.vue?vue&type=style&index=0&id=31d29007&lang=scss&scoped=true"
import "./txssc.vue?vue&type=style&index=1&id=31d29007&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d29007"]])

export default __exports__